/* istanbul ignore file */
export { default } from './RadioButtonGroup';
